export function generateSignalUnitMap(gtemplate) {
  if (!Array.isArray(gtemplate?.datapoints) || !gtemplate?.datapoints?.length) {
    return new Map();
  }

  return gtemplate.datapoints.reduce((map, sc) => {
    if (!Array.isArray(sc?.values) || !sc?.values?.length) {
      return map;
    }

    return sc.values.reduce((acc, signal) => {
      const { _id, display_precision = 2, transforms, unit } = signal || {};
      if (!Array.isArray(transforms) || !transforms?.length) {
        return acc.set(_id, { display_precision, unit });
      }

      const [{ uom = unit }] = transforms;
      return acc.set(_id, { display_precision, unit: uom });
    }, map);
  }, new Map());
}
